module.exports = __webpack_public_path__ + "img/emoji_22.703fb2d8.png";